import { render, staticRenderFns } from "./ReporteDepreciacion.vue?vue&type=template&id=b20e550e"
import script from "./ReporteDepreciacion.vue?vue&type=script&lang=js"
export * from "./ReporteDepreciacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports